<div class="amount-card">
  <div *ngIf="setAmount(raised)" class="amount">
    <div *ngIf="vwoService.getTickrVariable() && fundraiser?.raised?.backers && fundraiser?.raised?.beforeTickrBackers>10 && !isFundraiserEnded; else lessBackers">
      <div *ngIf="showRaisedAmt">
        <app-currency-icon *ngIf="currency" [currency]="currency"></app-currency-icon>
        <!--Counto directive to animate number -->
        <span counto
          step="30"
          [countTo]="raised"
          [countFrom]="fundraiser.raised.beforeTickr ? fundraiser.raised.beforeTickr : raised"
          (countoChange)="counto = $event" duration="1">
          {{ counto  | inrFormat:currency}}
        </span>
      </div>
      <app-placeholder-loader *ngIf="!showRaisedAmt" type="text" [count]="1"></app-placeholder-loader>
    </div>
    <ng-template #lessBackers>
      <div>
        <app-currency-icon *ngIf="currency" [currency]="currency"></app-currency-icon>
        {{(raised?raised:'0') | inrFormat:currency}}
      </div>
    </ng-template>
  </div>
  <span *ngIf="currency && goal && setAmount(raised)" class="raised">
    {{isFundraiserEnded?'raised':'raised of'}}
    <span *ngIf="!isFundraiserEnded && goal!==0">
      <span *ngIf="currency" class="numbers">
        <app-currency-icon [currency]="currency"></app-currency-icon>
        {{goal | inrFormat:currency}}
      </span> goal
    </span>
  </span>
  <div class="progressbar">
    <app-progress-bar *ngIf="!isFundraiserEnded && setAmount(raised) && goal && goal!==0" [amount]="raised" [goal]="goal" height="12px"></app-progress-bar>
  </div>
  <div class="amount-footer">
    <span *ngIf="!fundraiser?.settings?.nodonorlist" class="raised supporters"> <span class="numbers">{{supporters?supporters:0}}</span> supporters</span>
    <span *ngIf="!isFundraiserEnded && date && !fundraiser?.settings?.hidedaysleft" class="raised supporters">
      <span *ngIf="(date | dayjs:'diffInDays') >= 0" class="numbers">{{+(date | dayjs:'diffInDays') + 1}}</span> days left
    </span>
  </div>
</div>
